import { useGetAdminPayerByIdQuery, useGetPayerByIdQuery } from '@features/payer-search/store/api';
import { Button, Stack, Typography } from '@mui/material';

/** Staff reads use staff authorization and do not require clinic membership. */
export function AdminCredentialingPayerName({ id }: { id: string }) {
  const { currentData, isFetching, refetch } = useGetAdminPayerByIdQuery({ payerId: id });
  return (
    <PayerName
      name={currentData?.display_name}
      pending={isFetching}
      onRetry={() => void refetch()}
    />
  );
}

/** RTK deduplicates repeated payer IDs across rows; each page has at most 25 distinct lookups. */
export function CredentialingPayerName({ id }: { id: string }) {
  const { currentData, isFetching, refetch } = useGetPayerByIdQuery({ payerId: id });
  return (
    <PayerName
      name={currentData?.display_name}
      pending={isFetching}
      onRetry={() => void refetch()}
    />
  );
}

function PayerName({
  name,
  pending,
  onRetry,
}: {
  name?: string;
  pending: boolean;
  onRetry: () => void;
}) {
  if (name) return <>{name}</>;
  if (pending) return <>Loading payer…</>;
  return (
    <Stack spacing={0.5} sx={{ alignItems: 'flex-start' }}>
      <Typography variant="body2">Payer name unavailable</Typography>
      <Button size="small" onClick={onRetry}>
        Retry payer name
      </Button>
    </Stack>
  );
}
